// src/pages/RideOptions.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import cabImg from '../assets/img/ride/cab.png';
import kekeImg from '../assets/img/ride/keke.png';
import okadaImg from '../assets/img/ride/okada.png';
import fallbackMap from '../assets/img/map.jpg';

const RideOptions = () => {
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAuth, setShowAuth] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const { pickupLocation = "Lekki Phase 1", dropoffLocation = "Victoria Island", serviceType = "cab" } = state;

  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => { const t = setTimeout(() => setLoading(false), 3000); return () => clearTimeout(t); }, []);

  const googleMapUrl = `https://maps.googleapis.com/maps/api/staticmap?size=1200x380&zoom=13&scale=2
    &markers=color:red%7Clabel:A%7C${encodeURIComponent(pickupLocation + ", Lagos")}
    &markers=color:green%7Clabel:B%7C${encodeURIComponent(dropoffLocation + ", Lagos")}
    &path=color:0x0000ff88%7Cweight:6%7C${encodeURIComponent(pickupLocation + ", Lagos")}%7C${encodeURIComponent(dropoffLocation + ", Lagos")}
    &key=YOUR_API_KEY`.replace(/\s/g, '');

  const getRideOptions = () => {
    const dist = Math.round(5 + Math.random() * 10);
    const time = Math.round(10 + Math.random() * 20);
    if (serviceType === 'cab') return [
      { name: 'Comfort Cab', eta: `${time-5}-${time} mins`, price: `₦${(dist*400).toLocaleString()} - ₦${(dist*520).toLocaleString()}`, features: 'AC • 4 seats', fastest: true },
      { name: 'Premium Cab', eta: `${time-3}-${time+2} mins`, price: `₦${(dist*600).toLocaleString()} - ₦${(dist*750).toLocaleString()}`, features: 'Leather • WiFi', fastest: false },
      { name: 'Executive Cab', eta: `${time+2}-${time+8} mins`, price: `₦${(dist*900).toLocaleString()} - ₦${(dist*1100).toLocaleString()}`, features: 'SUV • Privacy', fastest: false },
    ];
    if (serviceType === 'tricycle') return [
      { name: 'Keke Express', eta: `${time-8}-${time-3} mins`, price: `₦${(dist*120).toLocaleString()} - ₦${(dist*180).toLocaleString()}`, features: 'Fast in traffic', fastest: true },
      { name: 'Keke Plus', eta: `${time-6}-${time-1} mins`, price: `₦${(dist*160).toLocaleString()} - ₦${(dist*220).toLocaleString()}`, features: 'Roof cover', fastest: false },
    ];
    return [
      { name: 'Okada Pro', eta: `${time-10}-${time-6} mins`, price: `₦${(dist*80).toLocaleString()} - ₦${(dist*140).toLocaleString()}`, features: 'Beats traffic', fastest: true },
      { name: 'Okada Premium', eta: `${time-9}-${time-5} mins`, price: `₦${(dist*120).toLocaleString()} - ₦${(dist*180).toLocaleString()}`, features: 'Raincoat • Charger', fastest: false },
    ];
  };

  const rideOptions = getRideOptions();
  const serviceName = serviceType === 'cab' ? 'Cab' : serviceType === 'tricycle' ? 'Keke' : 'Okada';
  const vehicleImg = serviceType === 'cab' ? cabImg : serviceType === 'tricycle' ? kekeImg : okadaImg;

  const isLoggedIn = () => !!localStorage.getItem('user') || !!localStorage.getItem('token');

  const handleBook = () => {
    if (selectedOption === null) return;
    if (isLoggedIn()) {
      setShowSuccess(true);
    } else {
      setShowAuth(true);
    }
  };

  if (loading) {
    return (
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#f8f9fa'}}>
        <div style={{width:80,height:80,border:'8px solid #f0f7ee',borderTop:'8px solid #4eac3d',borderRadius:'50%',animation:'spin 1s linear infinite'}}></div>
      </div>
    );
  }

  return (
    <>
      {/* NORMAL GLOBAL STYLE – THIS FIXES THE MODAL */}
      <style jsx global>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes pop { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }

        .modal-backdrop {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        .modal-box {
          background: white;
          padding: 40px 30px;
          border-radius: 20px;
          text-align: center;
          max-width: 420px;
          width: 90%;
          box-shadow: 0 20px 60px rgba(0,0,0,0.4);
          animation: pop 0.4s ease-out;
        }
        .modal-box h3 { font-size: 26px; margin: 0 0 12px; color: #222; }
        .modal-box p { font-size: 16px; color: #555; margin: 0 0 24px; }
        .modal-btn {
          background: #4eac3d; color: white; border: none; padding: 14px 32px;
          border-radius: 50px; font-size: 16px; font-weight: 600; cursor: pointer; margin: 0 8px;
        }
        .modal-btn:hover { background: #3d8b30; }
        .modal-btn.secondary { background: #666; }
        .modal-btn.secondary:hover { background: #444; }
      `}</style>

      <style jsx>{`
        .ride-wrapper { padding:40px 0; background:#f8f9fa; min-height:100vh; }
        .ride-container { max-width:1200px; margin:auto; padding:0 15px; }
        .ride-card { background:white; border-radius:20px; overflow:hidden; box-shadow:0 20px 60px rgba(0,0,0,.1); }
        .pickup-info { background:#f0f7ee; padding:20px; border-bottom:1px solid #e0e0e0; }
        .pickup-info h5 { margin:0 0 8px; font-weight:700; font-size:18px; color:#222; }
        .pickup-info p { margin:0; font-size:15px; color:#555; }
        .map-container { height:380px; position:relative; overflow:hidden; }
        .map-img { width:100%; height:100%; object-fit:cover; }
        .map-overlay { position:absolute; bottom:16px; left:16px; background:rgba(0,0,0,.7); color:white; padding:12px 20px; border-radius:12px; font-size:16px; font-weight:600; }
        .ride-options { padding:28px 24px; }
        .option-card { border:2px solid transparent; border-radius:18px; padding:20px; margin-bottom:18px; cursor:pointer; transition:all .3s; background:#fff; display:flex; align-items:center; gap:20px; box-shadow:0 4px 20px rgba(0,0,0,.08); }
        .option-card:hover { border-color:#4eac3d; transform:translateY(-4px); }
        .option-card.selected { border-color:#4eac3d; background:#f8fff8; }
        .vehicle-img { width:90px; height:90px; object-fit:contain; background:#f9f9f9; padding:8px; border-radius:12px; }
        .price { font-size:24px; font-weight:800; color:#222; }
        .eta { font-size:15px; color:#666; margin:6px 0; }
        .features { font-size:14px; color:#777; }
        .fastest-badge { background:#4eac3d; color:white; font-size:11px; padding:6px 12px; border-radius:20px; margin-left:12px; }
        .choose-btn { background:#000; color:white; border:none; padding:18px; border-radius:16px; font-size:18px; font-weight:700; width:100%; margin-top:24px; cursor:pointer; }
        .choose-btn:hover { background:#333; }
        .choose-btn:disabled { background:#999; cursor:not-allowed; }
        @media(max-width:768px){ .option-card{flex-direction:column;text-align:center} .vehicle-img{width:110px;height:110px} }
      `}</style>

      <div className="ride-wrapper">
        <div className="ride-container">
          <div className="ride-card">
            <div className="pickup-info">
              <h5>From: {pickupLocation}</h5>
              <p>To: {dropoffLocation} • ~{Math.round(5+Math.random()*10)} km • {Math.round(10+Math.random()*20)} mins</p>
            </div>

            <div className="map-container">
              <img src={googleMapUrl} alt="Route" className="map-img"
                onError={e => { e.target.onerror = null; e.target.src = fallbackMap; }} />
              <div className="map-overlay">{pickupLocation} → {dropoffLocation}</div>
            </div>

            <div className="ride-options">
              <h4 style={{textAlign:'center', margin:'0 0 28px', fontSize:'22px', fontWeight:700}}>
                Available {serviceName} Options
              </h4>

              {rideOptions.map((ride, i) => (
                <div key={i} className={`option-card ${selectedOption === i ? 'selected' : ''}`}
                     onClick={() => setSelectedOption(i)}>
                  <img src={vehicleImg} alt={ride.name} className="vehicle-img" />
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center'}}>
                      <strong style={{fontSize:'19px'}}>{ride.name}</strong>
                      {ride.fastest && <span className="fastest-badge">Fastest</span>}
                    </div>
                    <div className="eta">{ride.eta}</div>
                    <div className="features">{ride.features}</div>
                  </div>
                  <div style={{textAlign:'right'}}>
                    <div className="price">{ride.price}</div>
                  </div>
                </div>
              ))}

              <button className="choose-btn" onClick={handleBook}
                style={{background: selectedOption !== null ? '#000' : '#999'}}>
                {selectedOption !== null ? `Book ${rideOptions[selectedOption].name}` : 'Select a ride first'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* SUCCESS MODAL */}
      {showSuccess && (
        <div className="modal-backdrop" onClick={() => setShowSuccess(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <h3>Ride Booked Successfully!</h3>
            <p>Your {rideOptions[selectedOption]?.name} is on the way!</p>
            <button className="modal-btn" onClick={() => setShowSuccess(false)}>OK</button>
          </div>
        </div>
      )}

      {/* AUTH MODAL */}
      {showAuth && (
        <div className="modal-backdrop" onClick={() => setShowAuth(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <h3>Login Required</h3>
            <p>You need to login or register to book a ride.</p>
            <button className="modal-btn" onClick={() => navigate('/login')}>Login</button>
            <button className="modal-btn secondary" onClick={() => navigate('/register')}>Register</button>
          </div>
        </div>
      )}
    </>
  );
};

export default RideOptions;